import React, { useEffect, useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

export default function PurchaseBillListPage() {
  const [bills, setBills] = useState([]);
  const [billItems, setBillItems] = useState({});
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchBills();
  }, []);

  // After fetching bills, fetch their items
  const fetchBills = async () => {
    const res = await api.get('/purchase-bills');
    setBills(res.data);
    // Fetch items for each bill and store in state as { [billId]: [items array] }
    const itemsObj = {};
    await Promise.all(
      res.data.map(async bill => {
        const resp = await api.get(`/purchase-bills/${bill.PurchaseBillID}/items`);
        itemsObj[bill.PurchaseBillID] = resp.data || [];
      })
    );
    setBillItems(itemsObj);
  };

  const handleDelete = async id => {
    if (!window.confirm('Delete this purchase bill?')) return;
    await api.delete(`/purchase-bills/${id}`);
    fetchBills();
  };

  const handleEdit = id => {
    navigate(`/purchase-bills/edit/${id}`);
  };

  const filteredBills = bills.filter(bill =>
    bill.BillNo.toLowerCase().includes(search.toLowerCase()) ||
    (bill.SupplierName && bill.SupplierName.toLowerCase().includes(search.toLowerCase())) ||
    (bill.Status && bill.Status.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="container py-4">
         <BackButton></BackButton>
      <h3 className="mb-3">Purchase Bills</h3>
      
      <div className="d-flex mb-3">
       
        <button className="btn btn-primary me-2" onClick={() => navigate('/purchase-bills/add')}>
          + Add Bill
        </button>
        <input
          type="text"
          className="form-control w-auto"
          placeholder="Search Bill No, Supplier, Status"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        
      </div>
      <div className="table-responsive">
        <table className="table table-bordered table-striped align-middle">
          <thead>
            <tr>
              <th>Bill No</th>
              <th>Date</th>
              <th>Supplier</th>
              <th>Status</th>
              <th>Taxable Amt</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>Total GST</th>
              <th>Total</th>
              <th>Discount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBills.map(bill => {
              const items = billItems[bill.PurchaseBillID] || [];
              const taxableAmt = items.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0);
              const cgst = items.reduce((sum, item) => sum + parseFloat(item.CGST || 0), 0);
              const sgst = items.reduce((sum, item) => sum + parseFloat(item.SGST || 0), 0);
              const igst = items.reduce((sum, item) => sum + parseFloat(item.IGST || 0), 0);
              const totalGST = cgst + sgst + igst;
              const grandTotal = taxableAmt + totalGST - parseFloat(bill.Discount || 0);

              return (
                <tr key={bill.PurchaseBillID}>
                  <td>{bill.BillNo}</td>
                  <td>{bill.BillDate ? new Date(bill.BillDate).toLocaleDateString() : ''}</td>
                  <td>{bill.SupplierName}</td>
                  <td>
                    <span
                      className={
                        bill.Status === 'Paid'
                          ? 'badge bg-success'
                          : bill.Status === 'Partial'
                          ? 'badge bg-warning text-dark'
                          : 'badge bg-danger'
                      }
                    >
                      {bill.Status}
                    </span>
                  </td>
                  <td>{taxableAmt.toFixed(2)}</td>
                  <td>{cgst.toFixed(2)}</td>
                  <td>{sgst.toFixed(2)}</td>
                  <td>{totalGST.toFixed(2)}</td>
                  <td>{grandTotal.toFixed(2)}</td>
                  <td>{parseFloat(bill.Discount || 0).toFixed(2)}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary me-1"
                      onClick={() => handleEdit(bill.PurchaseBillID)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-info me-1"
                      onClick={() => navigate(`/purchase-bills/items/${bill.PurchaseBillID}`)}
                    >
                      Items
                    </button>
                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => navigate(`/purchase-bills/payments/${bill.PurchaseBillID}`)}
                    >
                      Payments
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(bill.PurchaseBillID)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
            {filteredBills.length === 0 && (
              <tr>
                <td colSpan={11} className="text-center text-muted">
                  No purchase bills found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
